import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Grid, Typography, Link as MuiLink, Divider } from '@mui/material';
import { BRAND, FONT_FAMILY, CONTACT, whatsappLink } from '../brand';

const linkSx = {
    color: 'rgba(255,255,255,0.78)',
    textDecoration: 'none',
    fontFamily: FONT_FAMILY,
    fontSize: '0.92rem',
    fontWeight: 400,
    transition: 'color 0.2s',
    overflowWrap: 'anywhere',
    '&:hover': { color: BRAND.green },
};

const titleSx = {
    color: 'white',
    fontFamily: FONT_FAMILY,
    fontWeight: 600,
    fontSize: '0.95rem',
    mb: 0.5,
};

const External = ({ href, children }) => (
    <MuiLink href={href} target="_blank" rel="noopener noreferrer" sx={linkSx}>
        {children}
    </MuiLink>
);

const Internal = ({ to, children }) => (
    <MuiLink component={RouterLink} to={to} sx={linkSx}>
        {children}
    </MuiLink>
);

const Footer = () => (
    <Box
        component="footer"
        sx={{
            backgroundColor: BRAND.night,
            borderTop: `4px solid ${BRAND.green}`,
            color: 'white',
            pt: { xs: 6, md: 8 },
            pb: 4,
            mt: 'auto',
        }}
    >
        <Container maxWidth="lg" sx={{ py: 0 }}>
            <Grid container spacing={4} sx={{ mb: 5 }}>
                <Grid size={{ xs: 12, md: 4 }} sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                        <Box component="img" src="/videocallshop-logo.png" alt="" sx={{ width: 36, height: 36 }} />
                        <Typography sx={{ fontFamily: FONT_FAMILY, fontWeight: 700, fontSize: '1.2rem' }}>
                            VideoCallShop
                        </Typography>
                    </Box>
                    <Typography sx={{ fontFamily: FONT_FAMILY, fontWeight: 600, color: BRAND.green }}>
                        Comprá con alguien que te asesore.
                    </Typography>
                    <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '0.85rem', color: 'rgba(255,255,255,0.65)', maxWidth: 320 }}>
                        Conectamos compradores y comercios por videollamada para ver productos y recibir
                        asesoramiento en tiempo real.
                    </Typography>
                </Grid>

                <Grid size={{ xs: 6, md: 2.66 }} sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
                    <Typography sx={titleSx}>Para comercios</Typography>
                    <Internal to={CONTACT.landingPath}>Sumá tu comercio</Internal>
                    <Internal to={`${CONTACT.landingPath}#planes`}>Planes y precios</Internal>
                    <Internal to={`${CONTACT.landingPath}#agenda`}>Agendá una reunión</Internal>
                </Grid>

                <Grid size={{ xs: 6, md: 2.66 }} sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
                    <Typography sx={titleSx}>Ayuda</Typography>
                    <Internal to="/support">Soporte</Internal>
                    <External href={whatsappLink('¡Hola! Tengo una consulta sobre VideoCallShop.')}>
                        WhatsApp {CONTACT.whatsappDisplay}
                    </External>
                    <External href={`https://instagram.com/${CONTACT.instagram}`}>@{CONTACT.instagram}</External>
                    <MuiLink href={`mailto:${CONTACT.email}`} sx={linkSx}>
                        {CONTACT.email}
                    </MuiLink>
                </Grid>

                <Grid size={{ xs: 12, md: 2.66 }} sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
                    <Typography sx={titleSx}>Legal</Typography>
                    <Internal to="/terms">Términos y condiciones</Internal>
                    <Internal to="/privacy-policy">Política de privacidad</Internal>
                    <Internal to="/community-guidelines">Normas de la comunidad</Internal>
                </Grid>
            </Grid>

            <Divider sx={{ borderColor: 'rgba(255,255,255,0.12)', mb: 3 }} />

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '0.8rem', color: 'rgba(255,255,255,0.6)' }}>
                    Defensa de las y los Consumidores. Para reclamos{' '}
                    <MuiLink
                        href="https://www.argentina.gob.ar/produccion/defensadelconsumidor/formulario"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ color: 'rgba(255,255,255,0.8)' }}
                    >
                        ingresá acá
                    </MuiLink>
                    .
                </Typography>
                <Typography sx={{ fontFamily: FONT_FAMILY, fontSize: '0.8rem', color: 'rgba(255,255,255,0.6)' }}>
                    VIDEO CALL SHOP S.A.S. · Rosario, Santa Fe · VideoCallShop © 2024-{new Date().getFullYear()}
                </Typography>
                {/* Data Fiscal (ARCA/AFIP): agregar acá el QR oficial del comercio cuando se tenga el link propio. */}
            </Box>
        </Container>
    </Box>
);

export default Footer;
